<template>
  <div class="character-upload">
    <div v-if="!progress">
      <file-select @select="upload" />
    </div>
    <div v-else>
      <small v-if="progress === 100">Processing...</small>
      <small v-else>{{progress}}% Uploading</small>
    </div>
  </div>
</template>

<script>
import { CLOUD_NAME, CHARACTER_PRESET } from '@/utilities/cloudinaryKeys';
import cloudinaryUpload from '@/utilities/cloudinaryUpload';
import FileSelect from '@/components/FileSelect.vue';

export default {
  name: 'UploadCharacter',
  components: {
    FileSelect,
  },
  data() {
    return {
      progress: 0,
    };
  },
  methods: {
    upload(file) {
      const vm = this;
      vm.progress = 1;
      cloudinaryUpload({
        cloudName: CLOUD_NAME,
        preset: CHARACTER_PRESET,
        file,
        onProgress({ progress }) {
          vm.progress = progress;
        },
      }).then((response) => {
        this.$emit('complete', {
          url: response.secure_url,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.character-upload {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
